import { FC } from 'react'
import { Currency, formatCurrencyFull } from 'utilities/currency'

import classes from '../index.module.scss'

export const MetaInformation: FC = ({ children }) => (
  <div className={classes.amountAlert}>{children}</div>
)

export const Amount = ({ currency, value }: { currency: Currency; value: number }) => (
  <span>
    Amount: <strong>{formatCurrencyFull(value, currency)}</strong>
  </span>
)

export const Processed = ({ date, operationState }: { date: string; operationState: string }) =>
  operationState === 'Completed' ? (
    <span>
      Processed: <strong>{date}</strong>
    </span>
  ) : null

export const Submitted = ({ date }: { date: string }) => (
  <span>
    Submitted: <strong>{date}</strong>
  </span>
)
